<template>
  <div class="sysBaseForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :rules="rules"
      :disabled="$route.query.type == 'query'"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';

  export default {
    name: 'sysBaseForm',
    components: {
      baseForm,
    },
    props: ['type'],
    data() {
      return {
        baseData: {
          configName: null,
          configCode: null,
          configValue: null,
          configType: null,
          remark: null,
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 参数名称
            type: 'input',
            label: '配置名称',
            prop: 'configName',
            required: true,
          },
          {
            // 参数键名
            type: 'input',
            label: '配置键名',
            prop: 'configCode',
            required: true,
          },
          {
            // 参数键值
            type: 'input',
            label: '配置值',
            prop: 'configValue',
            required: true,
          },
          {
            type: 'dict',
            label: '系统配置类型',
            prop: 'configType',
            clearable: true,
            dictType: 'sysConfigType',
          },
        ];
      },
      rules() {
        return {};
      },
    },
    mounted() {},
    methods: {
      // 返回数据
      exportChildData() {
        // 点击提交，走校验
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
<style lang="scss" scoped></style>
